export enum MemberStatus {
  COUNTRY_ORGANISER = 'référent pays',
  MEMBER = 'membre',
  PARTNER = 'partenaire',
  WORLD_ORGANISER = 'référent monde',
}
